// Two-layer env, same mechanism as every Parsina client:
//  1. build time  — Parcel inlines process.env.* from .env / Dockerfile ENV;
//  2. runtime     — docker-entrypoint.sh writes /env.js with window.__ENV__,
//                   so one image serves staging and beta1 with different BFFs.
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

// The public campaign CRM edge (parsina.bff.crm). Origin only — the api
// module appends its own paths.
export const CRM_BFF_URL = (
  runtime.CRM_BFF_URL ||
  process.env.CRM_BFF_URL ||
  'https://leads.parsinabot.ir'
).replace(/\/+$/, '');

// Which campaign this deployment of the page belongs to. Attribution the
// visitor cannot fake arrives from config, not from the query string.
export const CAMPAIGN_CODE = runtime.CAMPAIGN_CODE || process.env.CAMPAIGN_CODE || 'drday';
